import { render, staticRenderFns } from "./NotificationForm.vue?vue&type=template&id=c66474bc&scoped=true"
import script from "./NotificationForm.vue?vue&type=script&lang=js"
export * from "./NotificationForm.vue?vue&type=script&lang=js"
import style0 from "./NotificationForm.vue?vue&type=style&index=0&id=c66474bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66474bc",
  null
  
)

export default component.exports